// extracted by mini-css-extract-plugin
module.exports = {"row":"Customers_row__3-mRI","col":"Customers_col__3VwTd","card":"Customers_card__w8gLk"};